export default "__VITE_ASSET__Ga0XowuM__"